export default __webpack_public_path__ + "static/media/thienkhong.7c0743a3.png";